/* Delivery promise timeline.
   Computes dispatch/delivery dates client-side (CDN-cached pages make
   server-side dates stale). Rules: dispatch Mon-Fri before the cutoff hour;
   after cutoff or on weekends, dispatch is the next working day. Delivery is
   the day after dispatch, skipping Sunday. Countdown refreshes every minute. */
class CandyDelivery extends HTMLElement {
  connectedCallback() {
    this.cutoffHour = parseInt(this.dataset.cutoff, 10) || 15;
    this.messageEl = this.querySelector('[data-delivery-message]');
    this.chipEl = this.querySelector('[data-delivery-countdown]');
    this.suffixEl = this.querySelector('[data-delivery-suffix]');
    this.dateEls = {
      order: this.querySelector('[data-delivery-date="order"]'),
      dispatch: this.querySelector('[data-delivery-date="dispatch"]'),
      delivery: this.querySelector('[data-delivery-date="delivery"]')
    };
    this.render();
    this.timer = setInterval(() => this.render(), 1000);
  }

  disconnectedCallback() {
    if (this.timer) clearInterval(this.timer);
  }

  isWorkingDay(date) {
    const day = date.getDay();
    return day >= 1 && day <= 5;
  }

  render() {
    const now = new Date();
    const cutoffToday = new Date(now);
    cutoffToday.setHours(this.cutoffHour, 0, 0, 0);

    const shipsToday = this.isWorkingDay(now) && now < cutoffToday;

    const dispatch = new Date(now);
    if (!shipsToday) {
      do {
        dispatch.setDate(dispatch.getDate() + 1);
      } while (!this.isWorkingDay(dispatch));
    }

    const delivery = new Date(dispatch);
    delivery.setDate(delivery.getDate() + 1);
    if (delivery.getDay() === 0) delivery.setDate(delivery.getDate() + 1);

    if (this.messageEl) {
      if (shipsToday) {
        const total = Math.floor((cutoffToday - now) / 1000);
        const h = Math.floor(total / 3600);
        const m = Math.floor((total % 3600) / 60);
        const s = total % 60;
        const pad = (n) => String(n).padStart(2, '0');
        this.messageEl.textContent = 'Order within';
        if (this.chipEl) {
          this.chipEl.hidden = false;
          this.chipEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
        }
        if (this.suffixEl) {
          this.suffixEl.textContent =
            'and it ships today, at your door ' + this.dayWord(delivery, now) + '.';
        }
      } else {
        this.messageEl.textContent =
          'Order now and it ships ' + this.dayWord(dispatch, now) + ', at your door ' + this.dayWord(delivery, now) + '.';
        if (this.chipEl) this.chipEl.hidden = true;
        if (this.suffixEl) this.suffixEl.textContent = '';
      }
    }

    if (this.dateEls.order) this.dateEls.order.textContent = this.shortDate(now);
    if (this.dateEls.dispatch) this.dateEls.dispatch.textContent = this.shortDate(dispatch);
    if (this.dateEls.delivery) this.dateEls.delivery.textContent = this.shortDate(delivery);
  }

  dayWord(date, now) {
    const today = new Date(now);
    today.setHours(0, 0, 0, 0);
    const target = new Date(date);
    target.setHours(0, 0, 0, 0);
    const diffDays = Math.round((target - today) / 86400000);
    if (diffDays === 0) return 'today';
    if (diffDays === 1) return 'tomorrow';
    return date.toLocaleDateString('en-GB', { weekday: 'long' });
  }

  shortDate(date) {
    return date.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  }
}

customElements.define('candy-delivery', CandyDelivery);
